import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import Chip from "@mui/material/Chip";
import Collapse from "@mui/material/Collapse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EventController from "./Controller/event_controller.ts";
import BasicDatePicker from "../../components/DatePicker/BasicDatePicker";
import BasicDateTimePicker from "../../components/DatePicker/BasicDateTimePicker";
import { notification } from "antd";
import { useSearchParams } from "react-router-dom";
import { Divider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import SelectInput from "../../components/TextInput/SelectInput";
import EventInfoTable from "../../components/Table/EventInfoTable.tsx";
import { useLocation } from "react-router-dom";
import TinyMCE from "../../components/EmailEditor/tinymce-email-builder.js";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import FormattedInputs from "../../components/AmountFormatter/FormattedInputs.js";

// import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor.js";
const DetailRow = ({ label, value }) => (
  <Grid container spacing={2} sx={{ mb: 1 }}>
    <Grid xs={6}>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
        {label}
      </Typography>
    </Grid>
    <Grid xs={6}>
      <Typography variant="body1" sx={{whiteSpace: 'pre-line', textAlign: 'justify'}}>{value || "-"}</Typography>
    </Grid>
  </Grid>
);
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <div {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: "rotate(0deg)",
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: "rotate(180deg)",
      },
    },
  ],
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Dashboard = () => {
  // expand button
  const [expanded, setExpanded] = React.useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  // tabs handle change
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // notification
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, msg) => {
    api[type]({
      message: msg,
      description: desc,
    });
  };
  // encryptor
  // const key = "12345";
  // const mode = "YMDHI";
  // const Encryptor = new InfinityEncryptor(key, mode);

  const [shouldRefetchData, setShouldRefetchData] = useState(false);
  const [data, setData] = useState([]); //payment is default during registration eg: registration fee & first year annual subscription fee
  const [Fee, setFee] = useState([]);

  const [searchParams] = useSearchParams();
  const eventID = searchParams.get("eventID");
  const userID = localStorage.getItem("userID");

  useEffect(() => {
    if (eventID) {
      const payload = new FormData();
      payload.append("eventID", eventID); // Append event ID
      EventController.getEditEventInfo(payload)
        .then((response) => {
          console.log(response)
          setData(response);
          setFee(response.fees);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [eventID, shouldRefetchData]);

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      event_name: "",
      event_desc: "",
      event_venue: "",
      registration_start_date: "",
      registration_end_date: "",
      event_schedules: "",
      website: "",
      date_of_incorporation: "",
      company_telephone_number: "",
      company_fax: "",
      company_email: "",
      gross_built_up_area: "",
      nett_lettable_area: "",
      event_categoryID: "",
    },
  });

  const formatSchedule = (schedule) => {
    if (!schedule) return "";
  
    // Split the schedule into date and time range
    const [date, timeRange] = schedule.split(" ");
    const [startTime, endTime] = timeRange.split("-");
  
    // Convert time to 12-hour format
    const formatTime = (time) => {
      const [hour, minute] = time.split(":").map(Number);
      const period = hour >= 12 ? "PM" : "AM";
      const formattedHour = hour % 12 || 12; // Convert 0 -> 12 for 12 AM
      return `${formattedHour}:${minute.toString().padStart(2, "0")} ${period}`;
    };
  
    return `${date} | ${formatTime(startTime)} - ${formatTime(endTime)}`;
  };

  useEffect(() => {
    if (data || (Fee && Fee.length > 0)) {
      reset({
        // Event details
        event_name: data?.event_name || "",
        event_desc: data?.event_desc || "",
        event_venue: data?.event_venue || "",
        registration_start_date: data?.registration_start_date || "",
        registration_end_date: data?.registration_end_date || "",
        early_bird_start_date: data?.early_bird_start_date || "",
        early_bird_end_date: data?.early_bird_end_date || "",
        event_start_date: data?.event_start_date || "",
        event_end_date: data?.event_end_date || "",
        event_schedules: data?.event_schedules || "",
        max_pax: data?.max_pax || "",
        publish_status: data?.publish_status || "",
        event_categoryID: data?.event_categoryID || "",
  
        // Fee details (Ensure Fee array has enough data)
        earlyBirdRateNonMembers: Fee[0]?.early_bird_rate || "",
        earlyBirdRateNonMembersGD: Fee[0]?.early_bird_group_discount_rate || "",
        normalRateNonMembers: Fee[0]?.normal_rate || "",
        normalRateNonMembersGD: Fee[0]?.group_discount_rate || "",

        earlyBirdRateMembers: Fee[1]?.early_bird_rate || "",
        earlyBirdRateMembersGD: Fee[1]?.early_bird_group_discount_rate || "",
        normalRateMembers: Fee[1]?.normal_rate || "",
        normalRateMembersGD: Fee[1]?.group_discount_rate || "",
  
        earlyBirdRateSupportingAssociations: Fee[2]?.early_bird_rate || "",
        earlyBirdRateSupportingAssociationsGD: Fee[2]?.early_bird_group_discount_rate || "",
        normalRateSupportingAssociations: Fee[2]?.normal_rate || "",
        normalRateSupportingAssociationsGD: Fee[2]?.group_discount_rate || "",

        min_pax: Fee[0]?.min_group_discount_pax || Fee[1]?.min_group_discount_pax || Fee[2]?.min_group_discount_pax || "",

      });
    }
  }, [data, Fee, reset]);
  
  

  const [schedules, setSchedules] = useState([{ date: null, start: null, end: null }]);
  const handleDataFromFormatterChildComponent = (data, value) => {};
  const [clearSelectMultipleInput, setClearSelectMultipleInput] =
    useState(false);

  dayjs.extend(customParseFormat); // ✅ Enable correct format parsing

  useEffect(() => {
    if (data.event_schedules) {
      setSchedules(
        data.event_schedules.split(",").map((schedule) => {
          const [date, timeRange] = schedule.trim().split(" ");
          if (!date || !timeRange) return { date: null, start: null, end: null }; // ✅ Prevents errors
  
          const [start, end] = timeRange.split("-");
          
          return {
            date: dayjs(date, "YYYY-MM-DD").isValid() ? dayjs(date, "YYYY-MM-DD") : null, // ✅ Ensure valid date
            start: start ? dayjs(start, "HH:mm") : null,  // ✅ Prevents invalid time
            end: end ? dayjs(end, "HH:mm") : null,        // ✅ Prevents invalid time
          };
        })
      );
    }
  }, [data.event_schedules]); // ✅ Runs when `data.event_schedules` updates
  

   // Function to update a schedule entry
   const handleScheduleChange = (index, field, value) => {
    const updatedSchedules = [...schedules];
    updatedSchedules[index][field] = value;
    setSchedules(updatedSchedules);
  };

  // Function to add a new schedule
  const addSchedule = () => {
    setSchedules([...schedules, { date: null, start: null, end: null }]);
  };

  // Function to remove a schedule
  const removeSchedule = (index) => {
    setSchedules(schedules.filter((_, i) => i !== index));
  };

  const onSubmit = async (row) => {
    const payload = new FormData();
    payload.append("ID", eventID); // Append event ID
    payload.append("userID", userID); // Append user ID
    payload.append('earlyBirdRateMembers', EmptyRateCleanup(row.earlyBirdRateMembers));
    payload.append('earlyBirdRateMembersGD', EmptyRateCleanup(row.earlyBirdRateMembersGD));
    payload.append('normalRateMembers', EmptyRateCleanup(row.normalRateMembers));
    payload.append('normalRateMembersGD', EmptyRateCleanup(row.normalRateMembersGD));
    payload.append('earlyBirdRateSupportingAssociations', EmptyRateCleanup(row.earlyBirdRateSupportingAssociations));
    payload.append('earlyBirdRateSupportingAssociationsGD', EmptyRateCleanup(row.earlyBirdRateSupportingAssociationsGD));
    payload.append('normalRateSupportingAssociations', EmptyRateCleanup(row.normalRateSupportingAssociations));
    payload.append('normalRateSupportingAssociationsGD', EmptyRateCleanup(row.normalRateSupportingAssociationsGD));
    payload.append('earlyBirdRateNonMembers', EmptyRateCleanup(row.earlyBirdRateNonMembers));
    payload.append('earlyBirdRateNonMembersGD', EmptyRateCleanup(row.earlyBirdRateNonMembersGD));
    payload.append('normalRateNonMembers', EmptyRateCleanup(row.normalRateNonMembers));
    payload.append('normalRateNonMembersGD', EmptyRateCleanup(row.normalRateNonMembersGD));
    payload.append('min_pax', EmptyRateCleanup(row.min_pax));
  
    // Manually append only necessary fields
    Object.keys(row).forEach((field) => {
      if (
        !field.startsWith("_eventDate") && 
        !field.startsWith("_eventStartTime") && 
        !field.startsWith("_eventEndTime") && 
        field !== "event_poster" 
        &&
        field !== "earlyBirdRateMembers" &&
        field !== "earlyBirdRateMembersGD" &&
        field !== "normalRateMembers" &&
        field !== "normalRateMembersGD" &&
        field !== "earlyBirdRateSupportingAssociations" &&
        field !== "earlyBirdRateSupportingAssociationsGD" &&
        field !== "normalRateSupportingAssociations" &&
        field !== "normalRateSupportingAssociationsGD" &&
        field !== "earlyBirdRateNonMembers" &&
        field !== "earlyBirdRateNonMembersGD" &&
        field !== "normalRateNonMembers" &&
        field !== "normalRateNonMembersGD" &&
        field !== "min_pax"
      ) {
        payload.append(`data[${field}]`, row[field]); // Add only valid form fields
      }
    });
  
    // Append the event poster file (if uploaded)
    if (row.event_poster && row.event_poster.length > 0) {
      const file = row.event_poster[0]["originFileObj"];
      payload.append("event_poster", file);
    }
  
    // Format and append event schedules
    const formattedSchedules = schedules
      .filter((s) => s.date && s.start && s.end) // Ensure no empty values
      .map((s) => `${s.date.format("YYYY-MM-DD")} ${s.start.format("HH:mm")}-${s.end.format("HH:mm")}`)
      .join(",");
  
    payload.append("event_schedules", formattedSchedules);
  
    // 🔹 Debugging: Log FormData contents
    // for (const pair of payload.entries()) {
    //   console.log(pair[0], pair[1]);
    // }
  
    // 🔹 Send to API (uncomment when ready)
    try {
      const response = await EventController.saveRow(payload);
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Your data has been saved successfully!",
          "Success"
        );
        setShouldRefetchData((prev) => !prev); // Re-trigger useEffect
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const EmptyRateCleanup = (rate) => {
    if(rate.trim() != '')
      return rate.trim();
    else
      return '0';
  }
  

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  const location = useLocation();
  const pathname = location.pathname;

  const tabConfig = {
    "/admin/event_info": {
      label:
        Number(data.event_categoryID) === 5
          ? "Meeting Invitation"
          : Number(data.event_categoryID) === 16
          ? "Announcement Blast"
          : "Registered Members",
      component: <EventInfoTable eventID={eventID} />,
    },
  };

  const currentTab = tabConfig[pathname];

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: "100%",
        width: "100vw",
      }}
    >
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {contextHolder}
        <Typography gutterBottom variant="h5"  sx={{ whiteSpace: "pre-line" }}>
          <Box sx={{ fontWeight: "bold", m: 1 }}>
            {data.event_name} 
            </Box>
        </Typography>
        {pathname === "/admin/event_info" && (
          <>
            <Card variant="outlined">
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h6"
                  sx={{ color: "text.secondary" }}
                >
                  {data.event_categoryID === 5
                    ? "Meeting"
                    : data.event_categoryID === 16
                    ? "Announcement"
                    : "Event"}
                </Typography>

                <Typography variant="h5" component="div">
                  {/* {data.event_name} */}
                </Typography>
                <Typography
                  variant="h7"
                  sx={{ color: "text.secondary", mb: 1.5 }}
                >
                  Status:{" "}
                  {data.publish_status === 1 ? (
                    <Chip label="Published" color="success" />
                  ) : (
                    <Chip label="Not Published" color="error" />
                  )}
                </Typography>
              </CardContent>

              <Grid container spacing={3} sx={{ p: 3, alignItems: "stretch" }}>
                {/* Basic Information */}
                <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                  <Paper elevation={3} sx={{ p: 3, borderRadius: 2, width: "100%", height: "100%" }}>
                    <Typography variant="h6" gutterBottom sx={{ whiteSpace: "pre-line" }} >Basic Information</Typography>
                    <Divider sx={{ mb: 2 }} />
                    <DetailRow label="Event Type" value={data.event_category_name} />
                    <DetailRow label="Description" value={data.event_desc} />
                    <DetailRow label="Venue" value={data.event_venue} />
                  </Paper>
                </Grid>

                {/* Registration Details */}
                <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                  <Paper elevation={3} sx={{ p: 3, borderRadius: 2, width: "100%", height: "100%" }}>
                    <Typography variant="h6" gutterBottom>Registration Details</Typography>
                    <Divider sx={{ mb: 2 }} />
                    <DetailRow label="Registration Start Date" value={data.registration_start_date} />
                    <DetailRow label="Registration End Date" value={data.registration_end_date} />
                  </Paper>
                </Grid>

                {/* Event Schedule */}
                <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                  <Paper elevation={3} sx={{ p: 3, borderRadius: 2, width: "100%", height: "100%" }}>
                    <Typography variant="h6" gutterBottom>Event Schedule</Typography>
                    <Divider sx={{ mb: 2 }} />
                    {data.event_schedules ? (
                      data.event_schedules.split(",").map((schedule, index) => (
                        <DetailRow key={index} label={`Event Day ${index + 1}`} value={formatSchedule(schedule)} />
                      ))
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        No event schedule available
                      </Typography>
                    )}
                  </Paper>
                </Grid>

                  {/* Section: Additional Information */}
                <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                  <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                    <Typography variant="h5" gutterBottom>
                      Additional Information
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <DetailRow label="Maximum Pax" value={data.max_pax} />
                  </Paper>
                </Grid>
              </Grid>


              <CardActions>
                <Button onClick={handleExpandClick} size="small">
                  Edit
                  <ExpandMore
                    expand={expanded}
                    aria-expanded={expanded}
                    aria-label="show more"
                  >
                    <ExpandMoreIcon />
                  </ExpandMore>
                </Button>
              </CardActions>
            </Card>
          </>
        )}

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <form
              onSubmit={handleSubmit(onSubmit, onInvalid, {
                shouldFocusError: true,
              })}
            >
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Event Name</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("event_name", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Event Category</Typography>
                </Grid>
                <Grid size={8}>
                  <SelectInput
                    type="text"
                    {...register("event_categoryID", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.event_categoryID
                        ? errors.event_categoryID.message
                        : ""
                    }
                    control={control}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Event Description</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("event_desc", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Venue</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("event_venue", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              {/* Early Bird Registration Start */}
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Early Bird Registration Start Date</Typography>
                </Grid>
                <Grid size={8}>
                  <BasicDatePicker
                    {...register("early_bird_start_date", {
                      // required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.early_bird_start_date
                        ? errors.early_bird_start_date.message
                        : ""
                    }
                    control={control}
                    name="early_bird_start_date"
                  />
                </Grid>
              </Grid>

              {/* Early Bird Registration End */}
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Early Bird Registration End Date</Typography>
                </Grid>
                <Grid size={8}>
                  <BasicDatePicker
                    {...register("early_bird_end_date", {
                      // required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.early_bird_end_date
                        ? errors.early_bird_end_date.message
                        : ""
                    }
                    control={control}
                    name="early_bird_end_date"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Registration Start Date</Typography>
                </Grid>
                <Grid size={8}>
                  <BasicDatePicker
                    {...register("registration_start_date", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.registration_start_date
                        ? errors.registration_start_date.message
                        : ""
                    }
                    control={control}
                    name="registration_start_date"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Registration End Date</Typography>
                </Grid>
                <Grid size={8}>
                  <BasicDatePicker
                    {...register("registration_end_date", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.registration_end_date
                        ? errors.registration_end_date.message
                        : ""
                    }
                    control={control}
                    name="registration_end_date"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Event Start Date</Typography>
                </Grid>
                <Grid size={8}>
                  <BasicDatePicker
                    {...register("event_start_date", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.event_start_date
                        ? errors.event_start_date.message
                        : ""
                    }
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Event End Date</Typography>
                </Grid>
                <Grid size={8}>
                  <BasicDatePicker
                    {...register("event_end_date", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.event_end_date
                        ? errors.event_end_date.message
                        : ""
                    }
                    control={control}
                  />
                </Grid>
              </Grid>

              {/* Event Schedule */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid container spacing={2} sx={{ p: 2 }}>
                  <Grid size={12}>
                    <Typography variant="h6">Event Schedules</Typography>
                    <Divider sx={{ mb: 2 }} />
                  </Grid>

                  { schedules.map((schedule, index) => (
                      <Grid container size={12} spacing={2} key={index} sx={{ mb: 2 }}>
                          <Grid size={4}>
                              <Typography variant="h7">
                                  Event Date (Day {index + 1})
                              </Typography>
                          </Grid>
                          <Grid size={3}>
                              <Controller
                                  name={`_eventDate_${index}`} // ✅ Unique but prefixed with `_`
                                  control={control}
                                  defaultValue={schedule.date || null}
                                  render={({ field }) => (
                                      <DatePicker
                                          label={`Event Date (Day ${index + 1})`}
                                          value={field.value}
                                          format="DD/MM/YYYY"
                                          onChange={(date) => {
                                              field.onChange(date);
                                              handleScheduleChange(index, "date", date);
                                          }}
                                          sx={{
                                            width: "100%",
                                            "& .MuiOutlinedInput-root": {
                                              fontSize: "16px",
                                              borderRadius: "25px",
                                              color: "black", // Set the input text color to black
                                              backgroundColor: "white", // Set background color to white
                                              "& fieldset": {
                                                borderColor: "#ccc", // Default border color
                                              },
                                              "&:hover fieldset": {
                                                borderColor: "#999", // Border color on hover
                                              },
                                            },
                                          }}
                                      />
                                  )}
                              />
                          </Grid>
                          <Grid size={2}>
                              <Controller
                                  name={`_eventStartTime_${index}`} // ✅ Unique but prefixed with `_`
                                  control={control}
                                  defaultValue={schedule.start || null}
                                  render={({ field }) => (
                                      <TimePicker
                                          label="Start Time"
                                          value={field.value}
                                          onChange={(time) => {
                                              field.onChange(time);
                                              handleScheduleChange(index, "start", time);
                                          }}
                                          sx={{
                                            width: "100%",
                                            "& .MuiOutlinedInput-root": {
                                              fontSize: "16px",
                                              borderRadius: "25px",
                                              color: "black", // Set the input text color to black
                                              backgroundColor: "white", // Set background color to white
                                              "& fieldset": {
                                                borderColor: "#ccc", // Default border color
                                              },
                                              "&:hover fieldset": {
                                                borderColor: "#999", // Border color on hover
                                              },
                                            },
                                          }}
                                      />
                                  )}
                              />
                          </Grid>
                          <Grid size={2}>
                              <Controller
                                  name={`_eventEndTime_${index}`} // ✅ Unique but prefixed with `_`
                                  control={control}
                                  defaultValue={schedule.end || null}
                                  render={({ field }) => (
                                      <TimePicker
                                          label="End Time"
                                          value={field.value}
                                          onChange={(time) => {
                                              field.onChange(time);
                                              handleScheduleChange(index, "end", time);
                                          }}
                                          sx={{
                                            width: "100%",
                                            "& .MuiOutlinedInput-root": {
                                              fontSize: "16px",
                                              borderRadius: "25px",
                                              color: "black", // Set the input text color to black
                                              backgroundColor: "white", // Set background color to white
                                              "& fieldset": {
                                                borderColor: "#ccc", // Default border color
                                              },
                                              "&:hover fieldset": {
                                                borderColor: "#999", // Border color on hover
                                              },
                                            },
                                          }}
                                      />
                                  )}
                              />
                          </Grid>
                          <Grid size={1}>
                              <Button variant="contained" color="error" onClick={() => removeSchedule(index)}>
                                  Remove
                              </Button>
                          </Grid>
                      </Grid>
                  ))}

                  <Grid item xs={12}>
                    <Button variant="contained" color="success" onClick={addSchedule}>
                      Add Schedule
                    </Button>
                  </Grid>

                  <input
                    type="hidden"
                    {...register("event_schedules")}
                    value={schedules
                      .filter((s) => s.date && s.start && s.end)
                      .map(
                        (s) =>
                          `${s.date.format("YYYY-MM-DD")} ${s.start.format("HH:mm")}-${s.end.format("HH:mm")}`
                      )
                      .join(",")}
                  />
                </Grid>
              </LocalizationProvider>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Maximum Pax</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="number"
                    {...register("max_pax", {
                      // required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Minimum Pax for Discount Group</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="number"
                    name='min_pax'
                    {...register("min_pax", {
                      // required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Publish Status</Typography>
                </Grid>
                <Grid size={8}>
                  <SelectInput
                    type="text"
                    {...register("publish_status", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.publish_status ? errors.publish_status.message : ""
                    }
                    control={control}
                  />
                </Grid>
              </Grid>

              {/* Event Fees */}
              <Grid container spacing={2} sx={{ p: 2 }}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 750 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell align="left">
                        <Box component="div" sx={{ display: "inline" }}>
                          PPK Members
                        </Box>
                      </TableCell>
                      <TableCell align="left">
                        <Box component="div" sx={{ display: "inline" }}>
                          Supporting Associations
                        </Box>
                      </TableCell>
                      <TableCell align="left">
                        <Box component="div" sx={{ display: "inline" }}>
                          Non-members
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {"Early Bird (Single Registration)"}
                      </TableCell>
                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name="earlyBirdRateMembers"
                            {...register("earlyBirdRateMembers", {
                              required: false,
                            })}
                            onErrorCheck={
                              errors.earlyBirdRateMembers
                                ? errors.earlyBirdRateMembers.message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue}
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"earlyBirdRateSupportingAssociations"}
                            {...register(
                              "earlyBirdRateSupportingAssociations",
                              {
                                required: false,
                              }
                            )}
                            onErrorCheck={
                              errors.earlyBirdRateSupportingAssociations
                                ? errors
                                    .earlyBirdRateSupportingAssociations
                                    .message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue} // Pass setValue to the child component
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>

                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"earlyBirdRateNonMembers"}
                            {...register("earlyBirdRateNonMembers", {
                              required: false,
                            })}
                            onErrorCheck={
                              errors.earlyBirdRateNonMembers
                                ? errors.earlyBirdRateNonMembers.message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue} // Pass setValue to the child component
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {"Early Bird (Group Discounted Rate)"}
                      </TableCell>
                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"earlyBirdRateMembersGD"}
                            {...register("earlyBirdRateMembersGD", {
                              required: false,
                            })}
                            onErrorCheck={
                              errors.earlyBirdRateMembersGD
                                ? errors.earlyBirdRateMembersGD.message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue}
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"earlyBirdRateSupportingAssociationsGD"}
                            {...register(
                              "earlyBirdRateSupportingAssociationsGD",
                              {
                                required: false,
                              }
                            )}
                            onErrorCheck={
                              errors.earlyBirdRateSupportingAssociationsGD
                                ? errors
                                    .earlyBirdRateSupportingAssociationsGD
                                    .message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue} // Pass setValue to the child component
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>

                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"earlyBirdRateNonMembersGD"}
                            {...register("earlyBirdRateNonMembersGD", {
                              required: false,
                            })}
                            onErrorCheck={
                              errors.earlyBirdRateNonMembersGD
                                ? errors.earlyBirdRateNonMembersGD.message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue} // Pass setValue to the child component
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {"Normal Rate (Single Registration)"}
                      </TableCell>
                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"normalRateMembers"}
                            {...register("normalRateMembers", {
                              required: "This field is required",
                            })}
                            onErrorCheck={
                              errors.normalRateMembers
                                ? errors.normalRateMembers.message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue}
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"normalRateSupportingAssociations"}
                            {...register(
                              "normalRateSupportingAssociations",
                              {
                                required: false,
                              }
                            )}
                            onErrorCheck={
                              errors.normalRateSupportingAssociations
                                ? errors.normalRateSupportingAssociations
                                    .message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue} // Pass setValue to the child component
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>

                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"normalRateNonMembers"}
                            {...register("normalRateNonMembers", {
                              required: false,
                            })}
                            onErrorCheck={
                              errors.normalRateNonMembers
                                ? errors.normalRateNonMembers.message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue} // Pass setValue to the child component
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {"Normal Rate (Group Discounted Rate)"}
                      </TableCell>
                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"normalRateMembersGD"}
                            {...register("normalRateMembersGD", {
                              required: false,
                            })}
                            onErrorCheck={
                              errors.normalRateMembersGD
                                ? errors.normalRateMembersGD.message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue}
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"normalRateSupportingAssociationsGD"}
                            {...register(
                              "normalRateSupportingAssociationsGD",
                              {
                                required: false,
                              }
                            )}
                            onErrorCheck={
                              errors.normalRateSupportingAssociationsGD
                                ? errors
                                    .normalRateSupportingAssociationsGD
                                    .message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue} // Pass setValue to the child component
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>

                      <TableCell align="right">
                        <Box component="div" sx={{ display: "inline" }}>
                          <FormattedInputs
                            name={"normalRateNonMembersGD"}
                            {...register("normalRateNonMembersGD", {
                              required: false,
                            })}
                            onErrorCheck={
                              errors.normalRateNonMembersGD
                                ? errors.normalRateNonMembersGD.message
                                : ""
                            }
                            control={control}
                            clear={clearSelectMultipleInput}
                            setValue={setValue} // Pass setValue to the child component
                            onDataPass={
                              handleDataFromFormatterChildComponent
                            }
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              </Grid>

              <Button
                sx={{
                  backgroundColor: "#d33333",
                }}
                variant="contained"
                type="submit"
              >
                <Typography variant="h6">Save</Typography>
              </Button>
            </form>
          </CardContent>
        </Collapse>

        <Card variant="outlined" sx={{ mt: 6, mb: 6 }}>
          <CardContent>
            <Box sx={{ width: "100%" }}>
              {currentTab && (
                <>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs value={value} onChange={handleChange}>
                      <Tab label={currentTab.label} {...a11yProps(0)} />
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={value} index={0}>
                    {currentTab.component}
                  </CustomTabPanel>
                </>
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default Dashboard;
